<div class="call-rate-limit-banner" [ngClass]="variant" *ngIf="limits.length > 0" [dataHook]="'call-rate-limit-banner'">
  <div class="call-rate-limit-item" *ngFor="let limit of limits; trackBy: trackByNumber">
    <ng-icon class="call-rate-limit-icon" [name]="'heroExclamationTriangleSolid'" [size]="'18px'"></ng-icon>
    <span class="call-rate-limit-text">{{ message(limit) }}</span>
  </div>
</div>
